let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fMJrt")).then(() => parcelRequire('do41j'));